import { DSButton } from "components/UI/atoms";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

export const CartExpired = () => {
  const navigate = useNavigate();

  const handleContinue = () => navigate(INTERNAL_PATHS.BUY_GIFT_CARDS);

  return (
    <div className="cart-expired">
      <h2>Time’s up!&nbsp;Your cart expired.</h2>
      <p>
        This card has been removed from your cart. Please continue shopping to
        see what cards are still available.
      </p>
      <DSButton variant="secondary" onClick={handleContinue}>
        CONTINUE SHOPPING
      </DSButton>
    </div>
  );
};
